(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["recommendations"] && !Shopify.designMode) return;
  try {
    
const productRecommendationsSection = document.querySelector('.product-recommendations');
const productRecommendationsSectionWrapper = document.querySelector('.product-recommendations-wrapper');
const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(productRecommendationsSection);
    const url = productRecommendationsSection.dataset.url;
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
            $('[product-recommendations-title]').removeClass('hidden')
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
            productRecommendationsSectionWrapper.classList.remove('hidden')
            let initAjax = true
            theme.variants.init(initAjax);
        }
    })
    .catch(e => {
        console.error(e);
    });
};

const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
